import React, { useEffect, useRef } from "react";
import "./loading.scss";

function Loading() {
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    const text = "Welcome to AOIN DESIGNTECH — Designing the Future, Today.";
    const element = headingRef.current;
    let i = 0;
    let isCancelled = false;

    if (element) {
      element.innerHTML = "";

      const type = ()=> {
        if (isCancelled) return;

        if (i < text.length) {
          element.innerHTML += text.charAt(i);
          i++;
          setTimeout(type, 60);
        }
      }


      type();
    }

    return () => {
      isCancelled = true; // Cleanup if the component unmounts or re-renders
    };
  }, []);

  return (
    <div className="loading flex">
      <div className="imgContainer flex">
        <img src="/images/aoinLogoTransparentBackground.png" alt="" />
      </div>
      <div>
        <h1 className="headingFont typewriter" ref={headingRef}></h1>
      </div>
    </div>
  );
}

export default Loading;
